import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { USERS_FEATURE_KEY } from './keys';
import { usersReducer } from './reducers/users.reducer';
import { UsersEffects } from './effects/users.effects';
import { UsersUserBridge } from './bridges/users_user.bridge';

export function provideUsersStore(): EnvironmentProviders[] {
    return [provideState(USERS_FEATURE_KEY, usersReducer), provideEffects(UsersEffects, UsersUserBridge)];
}
